import { useMutation } from '@tanstack/react-query'
import { BeatArea, setBeatActive, setBeatArea } from 'supabase/importBeats'
import { queryClient } from 'utils'

// Every beat write refreshes the Beats list AND the Applications run-health
// banner, which judges only active beats: pausing or resuming one changes what
// the banner must look at.
const invalidate = () => {
  queryClient.invalidateQueries({ queryKey: ['importBeats'] })
  queryClient.invalidateQueries({ queryKey: ['importRunHealth'] })
}

/**
 * The two edits an admin may make to an existing beat: pause/resume and its
 * area. There is no mutation for page_url or handle (D-16).
 *
 * Errors are not swallowed (incl. 'beat not updated' for a write RLS refused):
 * the caller uses `mutateAsync` and maps them with `mapBeatError`.
 */
export const useUpdateImportBeat = () => {
  const setActive = useMutation({
    mutationFn: ({ handle, active }: { handle: string; active: boolean }) =>
      setBeatActive(handle, active),
    onSuccess: invalidate
  })

  const setArea = useMutation({
    mutationFn: ({ handle, area }: { handle: string; area: BeatArea }) =>
      setBeatArea(handle, area),
    onSuccess: invalidate
  })

  return { setActive, setArea }
}
